import defaultTheme from '@bookingForm/themes/default';
import productTheme from '@bookingForm/themes/product';
import modalTheme from '@bookingForm/themes/modal';
import upsellTheme from '@bookingForm/themes/upsell';
import swwTheme from '@bookingForm/themes/sww';
const STEP_NAMES = ['date', 'visitors', 'session'];
const STEP_COPY_KEYS = ['label', 'completedLabel', 'sublabel'];
const pickStepCopy = (source) => {
    if (!source || typeof source !== 'object') {
        return {};
    }
    const sourceRecord = source;
    const copy = {};
    STEP_COPY_KEYS.forEach((key) => {
        const value = sourceRecord[key];
        if (typeof value === 'string') {
            copy[key] = value;
        }
        else if (value === null) {
            copy[key] = undefined;
        }
    });
    return copy;
};
const mergeStepConfigCopy = (themeStepConfig, overrides) => {
    if (!overrides || typeof overrides !== 'object') {
        return themeStepConfig;
    }
    const overrideRecord = overrides;
    const merged = { ...themeStepConfig };
    STEP_NAMES.forEach((step) => {
        const copy = pickStepCopy(overrideRecord[step]);
        if (Object.keys(copy).length === 0) {
            return;
        }
        merged[step] = {
            ...(themeStepConfig?.[step] ?? {}),
            ...copy,
        };
    });
    return merged;
};
const convertDataAttributes = (attributes) => {
    const returnedObject = {};
    const keys = Object.keys(attributes);
    Object.values(attributes).forEach((value, idx) => {
        const key = keys[idx];
        if (key === 'theme') {
            switch (value) {
                case 'product':
                    returnedObject[key] = {
                        ...defaultTheme,
                        ...productTheme,
                        layout: attributes.layout ?? 'winter-wonderland',
                        themeName: value,
                    };
                    break;
                case 'sww':
                    returnedObject[key] = {
                        ...defaultTheme,
                        ...swwTheme,
                        layout: attributes.layout ?? 'winter-wonderland',
                        themeName: value,
                    };
                    break;
                case 'upsell':
                    returnedObject[key] = {
                        ...defaultTheme,
                        ...upsellTheme,
                        layout: attributes.layout ?? 'winter-wonderland',
                        themeName: value,
                    };
                    break;
                case 'modal':
                    returnedObject[key] = {
                        ...defaultTheme,
                        ...modalTheme,
                        layout: attributes.layout ?? 'winter-wonderland',
                        themeName: value,
                    };
                    break;
                case 'winter-wonderland':
                case 'winterwonderland':
                default:
                    returnedObject[key] = { ...defaultTheme, themeName: value };
                    break;
            }
        }
        else {
            try {
                returnedObject[key] = JSON.parse(`${value}`);
            }
            catch (e) {
                returnedObject[key] = `${value}`;
            }
        }
    });
    if (typeof returnedObject.theme === 'undefined') {
        returnedObject.theme = defaultTheme;
    }
    const theme = returnedObject.theme;
    const stepConfigOverride = returnedObject.stepConfig;
    theme.stepConfig = mergeStepConfigCopy(theme.stepConfig, stepConfigOverride);
    delete returnedObject.stepConfig;
    return returnedObject;
};
export default convertDataAttributes;
